import { render, staticRenderFns } from "./GeneralSettingsLocaleLanguage.vue?vue&type=template&id=06a2f334&"
import script from "./GeneralSettingsLocaleLanguage.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsLocaleLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports